<div class="flex items-center justify-center">
  <div
    class="relative bg-white rounded-4xl shadow-lg overflow-hidden flex flex-col items-center px-4 py-2"
    [ngClass]="{ 'w-50 gap-1': small, 'w-62 gap-2': !small }"
  >
    <button
      (click)="addProduct()"
      class="absolute top-0 right-0 w-15 h-16 bg-(--RJ-primario) [clip-path:polygon(0_0,100%_0,100%_100%)] hover:bg-red-700 transition-colors cursor-pointer z-10 flex justify-end items-start"
    >
      <div class="text-white text-3xl font-bold pr-2.5 pt-1">
        @if (added) {
          <mat-icon>check</mat-icon>
        } @else {
          +
        }
      </div>
    </button>

    <div
      class="h-40 w-40 flex justify-center items-end shrink-0!"
      [ngClass]="{ 'h-30 w-30': small, 'h-40 w-40': !small }"
    >
      <img
        class="bg-contain bg-center bg-no-repeat shrink-0! h-[inherit]!"
        [src]="`../../../../assets/img/PNGs/${product?.Code}.png`"
        alt="{{ product?.Description }}"
      />
    </div>

    <div
      class="text-gray-800 leading-tight text-center h-9"
      [ngClass]="{ 'font-medium text-[13px]': small, 'font-medium text-sm': !small }"
    >
      {{ product?.Description }}
    </div>
    <p
      class="text-(--RJ-primario) text-2xl font-black"
      [ngClass]="{ 'text-xl': small, 'text-2xl': !small }"
    >
      {{ product?.Cost | currency: 'USD' : 'symbol' : '1.2-2' }}
    </p>
  </div>
</div>
